import React from "react";
import { QRCodeCanvas } from "qrcode.react";

function QrcodeCard({ title, qrUrl, downloadUrl, fileName }) {
  const handleDownload = () => {
    fetch(downloadUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const link = document.createElement("a");
        const objectUrl = URL.createObjectURL(blob);
        link.href = objectUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(objectUrl);
      })
      .catch((error) => console.error("Error downloading the file:", error));
  };

  return (
    <div className="caf-qr-card">
      <h3 className="caf-qr-card__title">{title}</h3>
      <QRCodeCanvas value={qrUrl} className="my-3 w-28" />
      <button
        type="button"
        className="caf-btn caf-btn--outline mt-1 min-h-[42px] px-5 text-sm"
        onClick={handleDownload}
      >
        Download
      </button>
    </div>
  );
}

export default QrcodeCard;
